// extracted by mini-css-extract-plugin
module.exports = {"clearBtn":"FormFieldSearch_clearBtn__WpoeX","searchBtn":"FormFieldSearch_searchBtn__6l8q4"};